import { INBOX_MODULES } from './inbox';

// Validation-protocol lifecycle stages. Keys mirror the stage constants in
// src/Application/Dashboard/Queries/ValidationProgramme.cs — the backend owns the key and
// decides which stage a protocol is at; the label, tone and order live here.
export const PROTOCOL_STAGE = Object.freeze({
  AUTHORING: 'authoring',
  UNDER_REVIEW: 'underReview',
  APPROVED: 'approved',
  EXECUTING: 'executing',
  EXECUTION_FAILED: 'executionFailed',
  EXECUTION_PASSED: 'executionPassed',
  VSR_UNDER_REVIEW: 'vsrUnderReview',
  VSR_SIGNED: 'vsrSigned',
});

// Drawn top-to-bottom in this order — earliest stage first, so the bar reads as a pipeline.
export const PROTOCOL_STAGE_ORDER = Object.freeze([
  PROTOCOL_STAGE.AUTHORING,
  PROTOCOL_STAGE.UNDER_REVIEW,
  PROTOCOL_STAGE.APPROVED,
  PROTOCOL_STAGE.EXECUTING,
  PROTOCOL_STAGE.EXECUTION_FAILED,
  PROTOCOL_STAGE.EXECUTION_PASSED,
  PROTOCOL_STAGE.VSR_UNDER_REVIEW,
  PROTOCOL_STAGE.VSR_SIGNED,
]);

export const PROTOCOL_STAGE_LABELS = Object.freeze({
  [PROTOCOL_STAGE.AUTHORING]: 'Authoring',
  [PROTOCOL_STAGE.UNDER_REVIEW]: 'Under Review',
  [PROTOCOL_STAGE.APPROVED]: 'Approved — not started',
  [PROTOCOL_STAGE.EXECUTING]: 'Executing',
  [PROTOCOL_STAGE.EXECUTION_FAILED]: 'Execution Failed',
  [PROTOCOL_STAGE.EXECUTION_PASSED]: 'Execution Passed',
  [PROTOCOL_STAGE.VSR_UNDER_REVIEW]: 'VSR Under Review',
  [PROTOCOL_STAGE.VSR_SIGNED]: 'VSR Signed',
});

// Short axis labels for the workload chart — the Inbox's group headers are too long for a
// category axis.
export const WORKLOAD_MODULE_LABELS = Object.freeze({
  [INBOX_MODULES.FMECA]: 'FMECA',
  [INBOX_MODULES.NPA]: 'NPA',
  [INBOX_MODULES.PROTOCOL]: 'Protocol',
});

// A review cycle waiting longer than this is called out as ageing.
export const REVIEW_AGEING_DAYS = 7;
